import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=7b6dbab3"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=7b6dbab3&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6dbab3')) {
      api.createRecord('7b6dbab3', component.options)
    } else {
      api.reload('7b6dbab3', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=7b6dbab3", function () {
      api.rerender('7b6dbab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/BaseModal.vue"
export default component.exports